var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"map-pane"},[_vm._v("\n    DEV202307-55 台帳記載証明書画面 \n    "),_c('div',[_vm._v("\n      KamiNormalModeSearch.vueにレイアウトされているパーツを参考に作成する\n    ")]),_c('Dialog',{attrs:{"error":"","open":_vm.authDialog,"ok":()=>_vm.authDialog=false,"to":'/',"title":"ユーザー認証","body":"ユーザー認証に失敗しました。ログインし直して下さい。"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }